var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-container"},[_c('div',{staticClass:"title"},[_vm._v("\n    产品信息\n  ")]),_vm._v(" "),_vm._l((_vm.detail),function(item){return [_c('GoodsInfoItem',{key:item.id,attrs:{"info":item}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1b58f2bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/share/confirm-order/components/OrderGoodsInfo.vue
// module id = null
// module chunks = 